import { render, staticRenderFns } from "./PageError.vue?vue&type=template&id=0a5bc096&"
import script from "./PageError.vue?vue&type=script&lang=js&"
export * from "./PageError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports